<template>
    <div class="d-flex m-3 gap-2 content">

    <!-- Main Content -->
    <div class="w-80 d-flex flex-column gap-4">
      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-1">Vertical Panel</h4>
        <h5 class="text-gray-600 mb-2">Vertical Panel is used when displaying pages that has its own sidebar menu.</h5>
      </div>
      <VerticalPanel />
    </div>

    <!-- Quick Links -->
    <!-- <div class="pl-3 w-20 d-flex flex-column position-sticky h-100" style="right: 0; bottom: 0; top: 25px;">
      <a
        v-for="(item, index) in styles" :key="index"
        :href="`#${item.link}`"
        class="decoration-none"
      >{{ item.name }}</a>
    </div> -->

  </div>
</template>

<script>
import VerticalPanel from '@/components/local/VerticalPanel/VerticalPanelOverview'

export default {
  components: { VerticalPanel }
}
</script>